import { Component, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { ConfirmationDialogContentComponent } from './confirmation-dialog-content.component';

@Component({
  selector: 'confirmation-dialog',
  template: '',
})
export class ConfirmationDialogComponent {
  static contentComponent = ConfirmationDialogContentComponent;

  @Input() options: MatDialogConfig = { autoFocus: true };

  private _message: any;
  @Input() set message(value: any) {
    this._message = value;
    if (this.dialogRef) {
      this.dialogRef.componentInstance['message'] = value;
    }
  }
  get message(): any {
    return this._message;
  }

  @Output() confirmed: EventEmitter<any> = new EventEmitter<any>();
  @Output() canceled: EventEmitter<any> = new EventEmitter<any>();

  dialogRef: any;

  constructor(private dialog: MatDialog) {}

  open() {
    const dialogRef = this.dialog.open(
      ConfirmationDialogContentComponent,
      this.options,
    );
    const instance = dialogRef.componentInstance;
    instance['message'] = this._message;
    instance['confirmed'].subscribe((value: any) => {
      this.confirmed.emit(value);
    });
    instance['canceled'].subscribe((value: any) => {
      this.canceled.emit(value);
    });
    this.dialogRef = dialogRef;
    dialogRef.afterClosed().subscribe(() => {
      this.dialogRef = null;
    });
  }

  close() {
    if (this.dialogRef) this.dialogRef.close();
  }
}
